import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function QuickView({ product, open, onClose }) {
  const { addItem } = useCart();
  const [size, setSize] = useState("");

  if (!product) return null;

  const handleAdd = () => {
    if (!size && product.sizes?.length) return toast.error("Please choose a size");
    addItem(product, size || "OS", 1);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-4xl p-0 bg-surface border-border" data-testid="quickview-modal">
        <div className="grid md:grid-cols-2">
          <div className="aspect-[3/4] bg-background overflow-hidden">
            <img src={product.images?.[0]} alt={product.name} className="w-full h-full object-cover"/>
          </div>
          <div className="p-8 md:p-10 flex flex-col">
            <div className="ie-overline text-brand-accent">{product.subtitle}</div>
            <h2 className="font-serif text-3xl md:text-4xl mt-3 leading-tight">{product.name}</h2>
            <div className="flex items-baseline gap-3 mt-4">
              <span className="font-serif text-2xl">₹{product.price.toLocaleString("en-IN")}</span>
              {product.compare_at_price && <span className="text-sm text-text-secondary line-through">₹{product.compare_at_price.toLocaleString("en-IN")}</span>}
            </div>
            <p className="text-sm text-text-secondary leading-relaxed mt-5 line-clamp-3">{product.description}</p>

            {product.sizes?.length > 0 && (
              <div className="mt-6">
                <div className="ie-overline text-text-secondary mb-3">Size</div>
                <div className="flex flex-wrap gap-2">
                  {product.sizes.map((s) => (
                    <button
                      key={s}
                      onClick={() => setSize(s)}
                      className={`min-w-[44px] h-10 px-3 border text-sm transition-colors ${size === s ? "bg-foreground text-background border-foreground" : "border-border hover:border-foreground"}`}
                      data-testid={`quickview-size-${s}`}
                    >
                      {s}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="mt-auto pt-8 grid grid-cols-2 gap-3">
              <button onClick={handleAdd} className="ie-btn-primary justify-center" data-testid="quickview-add-to-cart">Add to Bag</button>
              <Link to={`/product/${product.id}`} onClick={onClose} className="ie-btn-ghost justify-center" data-testid="quickview-view-detail">View Detail</Link>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
